import React__default from 'react';
import { useTranslation } from 'react-i18next';
import _default from './../external_lib/react-lottie/dist/index.js';
import Typography from '../Atoms/Typography.js';
import QsrOrderStatusShimmer from '../Components/Molecules/QsrOrderStatus/Web/index.shimmer.js';
import { OrderStatusEnum, OrderSuccessText } from '../Enums/order_status.enum.js';
import FoodReadyJson from "../assets/food-ready.animation-cf2c1b31.json";
import PreparingFoodJson from "../assets/preparing.animation-e6167a1e.json";
import CompletedJson from "../assets/completed.animation-da5ea93a.json";
import classNames from './../external_lib/classnames/index.js';
import Colors from '../Themes/Colors/colors.js';

var animationOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    },
    animationData: ''
};
function QsrOrderStatus(_a) {
    var variant = _a.variant, loading = _a.loading;
    if (loading)
        return React__default.createElement(QsrOrderStatusShimmer, null);
    var t = useTranslation(['translations']).t;
    var orderStatus = orderStatusHelper(t, variant);
    return (React__default.createElement("div", { className: classNames('qsr-order-status', {
            'qsr-order-status--preparing-food': OrderStatusEnum.PreparingFood === variant,
            'qsr-order-status--food-ready': OrderStatusEnum.FoodReady === variant,
            'qsr-order-status--cancelled': OrderStatusEnum.Cancelled === variant
        }) }, orderStatus === null || orderStatus === void 0 ? void 0 :
        orderStatus.icon,
        React__default.createElement(Typography, { variant: 'bodyTextOneMain', classes: classNames('qsr-order-status-text', {
                'qsr-order-status-text--food-ready': OrderStatusEnum.FoodReady === variant,
                'qsr-order-status-text--preparing': OrderStatusEnum.PreparingFood === variant,
                'qsr-order-status-text--completed': OrderStatusEnum.Completed === variant,
                'qsr-order-status-text--cancelled': variant === OrderStatusEnum.Cancelled
            }), color: OrderStatusEnum.Completed === variant ? Colors.GREEN : Colors.WHITE }, orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.label)));
}
var orderStatusHelper = function (
// eslint-disable-next-line @typescript-eslint/ban-types
t, variant) {
    try {
        switch (variant) {
            case OrderStatusEnum.PreparingFood:
                animationOptions.animationData = PreparingFoodJson;
                return {
                    label: t(OrderSuccessText.PreparingFood),
                    icon: (React__default.createElement(_default, { style: {
                            width: '700px',
                            position: 'absolute',
                            left: '50%',
                            top: '-5%',
                            transform: 'translateX(-45%)',
                            margin: '0 auto'
                        }, options: animationOptions }))
                };
            case OrderStatusEnum.FoodReady:
                animationOptions.animationData = FoodReadyJson;
                return {
                    label: t(OrderSuccessText.FoodReady),
                    icon: (React__default.createElement(_default, { style: {
                            width: '700px',
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            margin: '0 auto'
                        }, options: animationOptions }))
                };
            case OrderStatusEnum.Completed:
                animationOptions.animationData = CompletedJson;
                animationOptions.loop = true;
                return {
                    label: t(OrderSuccessText.Completed),
                    icon: React__default.createElement(_default, { height: 120, width: 120, options: animationOptions })
                };
            case OrderStatusEnum.Cancelled:
                return {
                    label: t(OrderSuccessText.Cancelled)
                };
            default:
                return null;
        }
    }
    catch (err) {
        console.log(err);
    }
};

export { QsrOrderStatus as default };
//# sourceMappingURL=QsrOrderStatus.js.map
